import { createSelector } from '@ngrx/store';

export const getPropertyTypeTemplatesState = createSelector(
    (state: any) => state.propertyTypeTemplates,
    (state: any) => state.get('list')
);

export const getCreatePropertyTypeTemplateState = createSelector(
    (state: any) => state.propertyTypeTemplates,
    (state: any) => state.get('createTemplate')
);

export const getUpdatePropertyTypeTemplateState = createSelector(
    (state: any) => state.propertyTypeTemplates,
    (state: any) => state.get('updateTemplate')
);
